import apiClient from "../lib/apiClient";
// =============== admin manage other infos =============== //

// Create other info
export const createOther = async (otherData) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.post(
      "/admin/create/other",
      otherData,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export const getOther = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/admin/get/other/${id}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export const getOtherPublic = async () => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      "/get/other",
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export const listOthers = async () => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      "/admin/list/others",
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

// Update other info
export const updateOther = async (id, otherData) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.put(
      `/admin/update/other/${id}`,
      otherData,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

// Delete other info
export const deleteOther = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.delete(
      `/admin/delete/other/${id}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};
